import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import Ckeditor from "./Ckeditor";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import {
    admin_permission_detail,
    get_cms_pages,
    list_all_pages,
    add_page,
    delete_page,
    toggle_page_status,
} from "../../../api/apiHandler";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";

export default function Pages() {
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [allPages, setAllPages] = useState([]);
    const [pageContents, setPageContents] = useState({});
    const [loading, setLoading] = useState(true);

    // Add page modal state
    const [showAddModal, setShowAddModal] = useState(false);
    const [newPageTitle, setNewPageTitle] = useState("");
    const [newPageKeyword, setNewPageKeyword] = useState("");
    const [addingPage, setAddingPage] = useState(false);

    // Delete confirmation
    const [deleteConfirm, setDeleteConfirm] = useState(null);

    const AdminId = localStorage.getItem("aID");
    const [permissions, setPermission] = useState([]);
    const role = localStorage.getItem("adminRole");

    // Fetch all pages list
    const fetchAllPages = () => {
        setLoading(true);
        list_all_pages({}).then((response) => {
            if (response.code === "1") {
                setAllPages(response.data);
                // Fetch content for each page
                response.data.forEach((page) => {
                    get_cms_pages({ keyword: page.keyword }).then((res) => {
                        if (res.code === "1") {
                            setPageContents((prev) => ({
                                ...prev,
                                [page.keyword]: res.data.content,
                            }));
                        }
                    });
                });
            } else {
                setAllPages([]);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchAllPages();
    }, []);

    const subAdminPermission = () => {
        admin_permission_detail({ id: AdminId })
            .then((response) => {
                if (response.code == 1) {
                    setPermission(response.data);
                } else {
                    setPermission([]);
                }
            })
            .catch((error) => {
                setPermission([]);
            });
    };

    useEffect(() => {
        if (role !== "S") {
            subAdminPermission();
        }
    }, []);

    const pagesPermission = permissions.find(
        (permission) => permission.menu_name === "Pages"
    );

    const isEditAllowed = pagesPermission && pagesPermission.edit === 1;
    const isAddAllowed = pagesPermission && pagesPermission.add === 1;
    const isDeleteAllowed = pagesPermission && pagesPermission.delete === 1;

    // Auto-generate keyword from title
    const handleTitleChange = (value) => {
        setNewPageTitle(value);
        const keyword = value
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, "")
            .replace(/\s+/g, "_")
            .substring(0, 50);
        setNewPageKeyword(keyword);
    };

    // Add new page
    const handleAddPage = () => {
        if (!newPageTitle.trim()) {
            TOAST_ERROR("Please enter a page title");
            return;
        }
        if (!newPageKeyword.trim()) {
            TOAST_ERROR("Please enter a valid keyword");
            return;
        }
        setAddingPage(true);
        add_page({
            title: newPageTitle.trim(),
            keyword: newPageKeyword.trim(),
            content: "",
            is_active: 1,
        }).then((response) => {
            if (response.code === "1") {
                TOAST_SUCCESS("Page added successfully!");
                setShowAddModal(false);
                setNewPageTitle("");
                setNewPageKeyword("");
                fetchAllPages();
            } else {
                TOAST_ERROR(response.message || "Failed to add page. Keyword may already exist.");
            }
            setAddingPage(false);
        }).catch(() => {
            TOAST_ERROR("Failed to add page");
            setAddingPage(false);
        });
    };

    // Delete page
    const handleDeletePage = (pageId) => {
        delete_page({ id: pageId }).then((response) => {
            if (response.code === "1") {
                TOAST_SUCCESS("Page deleted successfully!");
                setDeleteConfirm(null);
                fetchAllPages();
            } else {
                TOAST_ERROR(response.message || "Failed to delete page");
            }
        });
    };

    // Toggle publish/unpublish
    const handleToggleStatus = (pageId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
        toggle_page_status({ id: pageId, is_active: newStatus }).then((response) => {
            if (response.code === "1") {
                TOAST_SUCCESS(newStatus === 1 ? "Page published!" : "Page unpublished!");
                setAllPages((prev) =>
                    prev.map((p) =>
                        p.id === pageId ? { ...p, is_active: newStatus } : p
                    )
                );
            } else {
                TOAST_ERROR(response.message || "Failed to update status");
            }
        });
    };

    // Function to render HTML content safely
    const renderHtmlContent = (content) => {
        const processedContent = (content || '').replace(
            /<iframe([^>]+)src=["']([^"']+\.(mp4|webm|ogg))["']([^>]*)><\/iframe>/gi,
            '<video controls style="max-width: 100%;"><source src="$2"></video>'
        );
        return { __html: processedContent };
    };

    return (
        <>
            <JqueryLoad />
            <Hdashboard />
            <main>
                <div className="dashboard-app d-lg-flex">
                    <header className="dashboard-toolbar d-lg-flex justify-content-between">
                        <div className="align-items-center justify-content-between d-flex">
                            <div className="d-flex align-items-center">
                                <a className="menu-toggle align-items-center d-lg-none d-flex">
                                    <i className="fa fa-bars" />
                                </a>
                                <a href="index.php" className="d-lg-none d-block brand-logo">
                                    <img src="./assets/images/logo.png" alt="logo" />
                                </a>
                            </div>
                        </div>
                    </header>

                    <div className="mx-5 mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-4 mt-3">
                            <p className="fs-3 fw-500 mb-0">Pages / Policies</p>
                            {(isAddAllowed || role === "S") && (
                                <button
                                    className="btn-theme bg-yellow d-inline-block"
                                    onClick={() => setShowAddModal(true)}
                                >
                                    <i className="fa fa-plus me-2"></i>Add New Policy
                                </button>
                            )}
                        </div>

                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : allPages.length === 0 ? (
                            <div className="text-center py-5">
                                <p className="fs-5 text-muted">No pages found. Click "Add New Policy" to create one.</p>
                            </div>
                        ) : (
                            <div id="accordion" className="mt-4">
                                {allPages.map((page, index) => {
                                    const accordionKey = `accordion_${page.id}`;
                                    const collapseId = `collapse_${page.id}`;
                                    const headingId = `heading_${page.id}`;

                                    return (
                                        <div className="card mb-3" key={page.id}>
                                            <div className="card-header d-flex align-items-center justify-content-between" id={headingId}>
                                                <h5 className="mb-0 flex-grow-1">
                                                    <button
                                                        className="btn"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#${collapseId}`}
                                                        aria-expanded={activeAccordion === accordionKey}
                                                        onClick={() =>
                                                            setActiveAccordion(
                                                                activeAccordion === accordionKey ? null : accordionKey
                                                            )
                                                        }
                                                    >
                                                        <p className="fs-5 fw-500 d-flex align-items-center">
                                                            <i className={`fa fa-${activeAccordion === accordionKey ? 'minus' : 'plus'} me-2`}></i>
                                                            {page.title || page.keyword}
                                                            {page.is_active === 0 && (
                                                                <span className="badge bg-secondary ms-2" style={{ fontSize: '0.7rem' }}>Unpublished</span>
                                                            )}
                                                        </p>
                                                    </button>
                                                </h5>
                                                <div className="d-flex align-items-center gap-2 me-3">
                                                    {(isEditAllowed || role === "S") && (
                                                        <div className="form-check form-switch" title={page.is_active === 1 ? "Published - Click to unpublish" : "Unpublished - Click to publish"}>
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={page.is_active === 1}
                                                                onChange={() => handleToggleStatus(page.id, page.is_active)}
                                                                id={`switch_${page.id}`}
                                                                style={{ cursor: 'pointer', width: '40px', height: '20px' }}
                                                            />
                                                        </div>
                                                    )}
                                                    {(isDeleteAllowed || role === "S") && (
                                                        <>
                                                            {deleteConfirm === page.id ? (
                                                                <div className="d-flex align-items-center gap-1">
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleDeletePage(page.id)}
                                                                        title="Confirm Delete"
                                                                    >
                                                                        <i className="fa fa-check"></i>
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-secondary"
                                                                        onClick={() => setDeleteConfirm(null)}
                                                                        title="Cancel"
                                                                    >
                                                                        <i className="fa fa-times"></i>
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => setDeleteConfirm(page.id)}
                                                                    title="Delete Page"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            <div
                                                id={collapseId}
                                                className={`collapse ${activeAccordion === accordionKey ? "show" : ""}`}
                                                aria-labelledby={headingId}
                                                data-parent="#accordion"
                                            >
                                                <div className="card-body">
                                                    {isEditAllowed || role === "S" ? (
                                                        <Ckeditor data={{ content: pageContents[page.keyword], keyword: page.keyword }} />
                                                    ) : (
                                                        <div dangerouslySetInnerHTML={renderHtmlContent(pageContents[page.keyword])} />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </main>

            {/* Add New Policy Modal */}
            {showAddModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-500">Add New Policy Page</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowAddModal(false);
                                        setNewPageTitle("");
                                        setNewPageKeyword("");
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label fw-500">Page Title <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. Refund Policy"
                                        value={newPageTitle}
                                        onChange={(e) => handleTitleChange(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-500">Keyword (URL Slug) <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. refund_policy"
                                        value={newPageKeyword}
                                        onChange={(e) => setNewPageKeyword(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ""))}
                                    />
                                    <small className="text-muted">
                                        Auto-generated from title. Only lowercase letters, numbers, and underscores allowed.
                                    </small>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowAddModal(false);
                                        setNewPageTitle("");
                                        setNewPageKeyword("");
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn-theme bg-yellow d-inline-block"
                                    onClick={handleAddPage}
                                    disabled={addingPage}
                                >
                                    {addingPage ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Adding...
                                        </>
                                    ) : (
                                        "Add Page"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
